import React, { useEffect } from "react";
import { Table, CardBody, Col, CardHeader, Row, Card } from "reactstrap";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";
import { api } from "../../config";
import moment from "moment";
const PrintDoc = ({ innerRef, item, type }) => {
  const handleValidDate = (date, format) => {
    return moment.utc(date).local().format(format);
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{ overflow: "scroll" }}>
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 10px 40px 10px" }}>
        <Col lg={12}>
          <CardHeader className="border-bottom p-4">
            <div className="d-flex">
              <div className="flex-grow-1">
                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                <div className="mt-sm-3 mt-3">
                  <h4 className="text-uppercase fw-semibold">{item.client && item.client.label}</h4>
                  <h5 className="mb-0 fs-15 fw-semibold">PROYEK {item.branch && item.branch.label}</h5>
                </div>
              </div>
              <div className="mt-3">
                <table className="mt-5" style={{ width: "420px" }}>
                  <tbody>
                    <tr className="border-bottom-dashed">
                      <td style={{ width: "100px" }}>Supplier</td>
                      <td style={{ width: "20px" }}>:</td>
                      <td>{item.vendor && item.vendor.contact ? item.vendor && item.vendor.contact + ", " + item.vendor.label : item.vendor && item.vendor.label}</td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </CardHeader>
          <CardBody className="p-4">
            <Row className="g-3">
              <Col lg={3} xs={3}>
                <p className="text-muted mb-2 text-uppercase fw-semibold">No PO</p>
                <h5 className="fs-14 mb-0">
                  #<span id="invoice-no">{item.transaction_no || "PKG" + handleValidDate(item.transactionat, "YYYYMMDD") + item.id}</span>
                </h5>
              </Col>
              <Col lg={3} xs={3}>
                <p className="text-muted mb-2 text-uppercase fw-semibold">No Referensi</p>
                <h5 className="fs-14 mb-0">
                  #<span id="invoice-no">{item.transaction_reff}</span>
                </h5>
              </Col>
              <Col lg={3} xs={3}>
                <p className="text-muted mb-2 text-uppercase fw-semibold">Tanggal</p>
                <h5 className="fs-14 mb-0">
                  <span id="invoice-date">{handleValidDate(item.transactionat, "MMM D, YYYY")}</span>
                </h5>
              </Col>
              <Col lg={3} xs={3}>
                <p className="text-muted mb-2 text-uppercase fw-semibold">Total</p>
                <h5 className="fs-14 mb-0">
                  <span id="total-amount">{currencyFormat(item.total_amount)}</span>
                </h5>
              </Col>
            </Row>
          </CardBody>
          <CardBody className="p-4">
            <div>
              <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                <thead>
                  <tr className="table-active">
                    <th scope="col" style={{ width: "50px" }}>
                      #
                    </th>
                    <th scope="col">Detail Produk</th>
                    <th scope="col">Anggaran</th>
                    <th scope="col">Harga</th>
                    <th scope="col">Jumlah</th>
                    <th scope="col">Satuan</th>
                    <th scope="col" className="text-end">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody id="products-list">
                  {item.items && item.items.length > 0 && (item.items.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' })) || []).map((o, i) => {
                    return (
                      <tr key={i} id={i} className="product">
                        <th scope="row" className="product-id">
                          {i + 1}
                        </th>
                        <td className="text-start">{o.name}</td>
                        <td className="text-start">{o.type} - {o.cvl_account}</td>
                        <td>Rp{currencyFormat(o.amount)}</td>
                        <td>{currencyFormat(o.quantity)}</td>
                        <td>{o.uom}</td>
                        <td className="text-end">
                          Rp{currencyFormat(o.total)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <div className="border-top border-top-dashed mt-2">
              <Table
                className="table table-borderless table-nowrap align-middle mb-0 ms-auto"
                style={{ width: "250px" }}>
                <tbody>
                  <tr>
                    <td>Sub Total</td>
                    <td className="text-end">
                      Rp{currencyFormat(item.sub_amount)}
                    </td>
                  </tr>
                  <tr>
                    <td>Diskon</td>
                    <td className="text-end">
                      Rp{currencyFormat(item.disc_amount)}
                    </td>
                  </tr>
                  <tr>
                    <td>Biaya Kirim</td>
                    <td className="text-end">
                      Rp{currencyFormat(item.shipment_amount)}
                    </td>
                  </tr>
                  <tr>
                    <td>Pajak {item.tax_percentage} %</td>
                    <td className="text-end">
                      Rp{currencyFormat(item.tax_amount)}
                    </td>
                  </tr>
                  <tr className="border-top border-top-dashed fs-15">
                    <th scope="row">Total</th>
                    <th className="text-end">
                      Rp{currencyFormat(item.total_amount)}
                    </th>
                  </tr>
                </tbody>
              </Table>
            </div>
            <div className="mt-4">
              <div className="alert alert-info">
                <p className="mb-0">
                  <span className="fw-semibold">NOTES:</span>
                  <span id="note"> {item.description}</span>
                </p>
              </div>
            </div>
            <Table
              className="table table-borderless table-nowrap align-middle mb-0 ms-auto"
              style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <p className="mb-0 text-center">Bogor, {handleValidDate(item.createdat, "MMM D, YYYY")}</p>
                    <p className="mb-0 text-center">Pengajuan</p>
                    <p className="mb-5 pb-3 fw-semibold text-center">{item.item_createdby ? item.item_createdby.name : ""}</p>
                    <p style={{ height: "10px" }}></p>
                    <p className="mt-5 text-center">................................</p>
                  </td>
                  <td>
                    <p className="mb-0 text-center">Bogor, {item.approvedat && handleValidDate(item.approvedat, "MMM D, YYYY")}</p>
                    <p className="mb-0 text-center">Disetujui Oleh</p>
                    <p className="mb-5 pb-3 fw-semibold text-center">{item.item_approvedby ? item.item_approvedby.name : ""}</p>
                    <p style={{ height: "10px" }}></p>
                    <p className="mt-5 text-center">................................</p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </CardBody>

          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <CardBody className="mt-5 p-4">
            <Row className="g-3 mt-3">
              {(item.item_file || []).map((f, i) => {
                if (f.isDeleted) {
                  return null;
                } else {
                  return (
                    <Col lg={6} xs={6} key={i}><img src={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" className="img-fluid rounded bg-light" /></Col>);
                }
              })}
            </Row>
          </CardBody>
        </Col>
      </div>
    </div>
  );
};

export default PrintDoc;
